module.exports = __webpack_public_path__ + "static/img/cloud-service_5463868.b4be684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cloud-service_5463868.png
// module id = xBKw
// module chunks = 1